<div class="form-wrapper" *ngIf="!paymentProcessing">
	<div id="open-edge-credit-card"></div>
	<input type="hidden" id="paytoken" on-change="getHeartlandToken(payToken.value)" (click)="getHeartlandToken(payToken.value);" #payToken/>
</div>
<div class="full-width full-height" *ngIf="paymentProcessing">
	<div class="align-items-center" style="height: 90px;">
		<mat-spinner [diameter]="30"></mat-spinner>
	</div>
</div>
